import { render, staticRenderFns } from "./ProductsWarehouses.vue?vue&type=template&id=5408b352"
import script from "./ProductsWarehouses.vue?vue&type=script&lang=js"
export * from "./ProductsWarehouses.vue?vue&type=script&lang=js"
import style0 from "./ProductsWarehouses.vue?vue&type=style&index=0&id=5408b352&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports